import { useCallback } from "react";
import { useLazyQuery } from "@apollo/client";
import { ROOM_SELECTION } from "graphql/service";

const debug = false;

type RoomSelectionRoom = {
  id: string;
  roomNumber: string;
};

type RoomSelectionResponse = {
  roomSelection: Array<{
    roomSelection: RoomSelectionRoom[];
  }>;
};

type RoomSelectionVars = {
  data: {
    checkInDate: string;
    checkOutDate: string;
    upgradeToIds: string[];
    bookingId: string;
  };
};

export const useIsRoomNumberAvailableForDates = () => {
  const [run, { loading, error }] = useLazyQuery<
    RoomSelectionResponse,
    RoomSelectionVars
  >(ROOM_SELECTION, { fetchPolicy: "no-cache" });

  const checkRoomNumberAvailability = useCallback(
    async (params: {
      bookingId: string;
      roomTypeId: string;
      roomNumber: string;
      checkInDate: string;
      checkOutDate: string;
    }) => {
      if (debug) {
        console.log(
          "(useIsRoomNumberAvailableForDates) - Cheking room number: ",
          params.roomNumber
        );
      }

      const payload = {
        bookingId: params.bookingId,
        checkInDate: params.checkInDate,
        checkOutDate: params.checkOutDate,
        upgradeToIds: [params.roomTypeId],
      };
      
      if (debug) {
        console.log(
          "(useIsRoomNumberAvailableForDates) ROOM_SELECTION PAYLOAD",
          payload
        );
      }
      
      const res = await run({
        variables: {
          data: payload,
        },
      });

      const rooms = res.data?.roomSelection?.[0]?.roomSelection ?? [];
      const normalizedTarget = String(params.roomNumber).trim();


      const isAvailable = rooms.some(
        (r) => String(r.roomNumber).trim() === normalizedTarget
      );

      if (debug) {
        console.log(
          "(useIsRoomNumberAvailableForDates) ROOM_SELECTION RESPONSE",
          res
        );
        console.log(
          "(useIsRoomNumberAvailableForDates) ROOM_SELECTION ERROR",
          res.error
        );
        console.log(
          "(useIsRoomNumberAvailableForDates) AVAILABLE ROOMS",
          rooms
        );
        console.log(
          "(useIsRoomNumberAvailableForDates) TARGET ROOM",
          params.roomNumber
        );
        console.log(
          "(useIsRoomNumberAvailableForDates) isAvailable",
          isAvailable
        );
      }

      return { isAvailable, rooms };
    },
    [run]
  );

  return { checkRoomNumberAvailability, loading, error };
};
